import React from 'react';
import { SVGUniqueID } from 'react-svg-unique-id';
import { ICustomIconProps } from './types';
import { appColors, backgroundColors } from 'src/consts/app-config';

export const closeIconColors = {
    white: appColors.white,
};

function CloseIcon({
    width,
    height,
    fullFillColor,
    onClick,
}: ICustomIconProps) {
    const currnetWidth = width || 30;
    const currnetHeight = height || 30;

    return (
        <SVGUniqueID>
            <svg
                onClick={() => {
                    onClick && onClick();
                }}
                width={currnetWidth}
                height={currnetHeight}
                viewBox='0 0 24 24'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
            >
                <g id='SVGRepo_bgCarrier' stroke-width='0'></g>
                <g
                    id='SVGRepo_tracerCarrier'
                    stroke-linecap='round'
                    stroke-linejoin='round'
                ></g>
                <g id='SVGRepo_iconCarrier'>
                    {' '}
                    <path
                        d='M15 9.00004L9 15M15 15L9 9.00004M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z'
                        stroke={fullFillColor?.white || 'black'}
                        stroke-width='2'
                        stroke-linecap='round'
                        stroke-linejoin='round'
                    ></path>{' '}
                </g>
            </svg>
        </SVGUniqueID>
    );
}

export default CloseIcon;
